var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"パスワード設定完了","description":"パスワードの設定が完了しました。","to":"login"}})}
var staticRenderFns = []

export { render, staticRenderFns }